/* Layout */
import Layout from '@/views/iori/layout/Layout'

/**
 * 平台框架相关路由
 */
const ioriRouter = [
    {
        path: '/sys/permission/',
        component: Layout,
        redirect: '/sys/permission/',
        children: [
            {
                path: 'grant',
                name: 'GrantManager',
                component: () => import('@/views/iori/grant/index')
            },
            {
                path: 'role',
                name: 'RoleManager',
                component: () => import('@/views/iori/role/index')
            },
            {
                path: 'program',
                name: 'ProgramManager',
                component: () => import('@/views/iori/program/index')
            }
        ]
    },
    {
        path: '/tenant/permission/',
        component: Layout,
        redirect: '/tenant/permission/',
        children: [
            {
                path: 'grant',
                name: 'TenantGrantManager',
                component: () => import('@/views/iori/grant/tenant/index')
            },
            {
                path: 'role',
                name: 'TenantRoleManager',
                component: () => import('@/views/iori/role/tenant/index')
            },
            {
                path: 'program',
                name: 'TenantProgramManager',
                component: () => import('@/views/iori/program/tenant/index')
            }
        ]
    },
    {
        path: '/sitemap',
        component: Layout,
        redirect: '/sitemap/list',
        children: [
            {
                path: 'list',
                name: 'Sitemap',
                component: () => import('@/views/iori/sitemap/index')
            }
        ]
    },
    {
        path: '/notify',
        component: Layout,
        redirect: '/notify/list',
        children: [
            {
                path: 'list',
                name: 'Notify',
                component: () => import('@/views/iori/notify/index')
            },
        ]
    },
    {
        path: '/tenant/notify/',
        component: Layout,
        redirect: '/tenant/notify/list',
        children: [
            {
                path: 'list',
                name: 'TenantNotify',
                component: () => import('@/views/iori/notify/tenant/index')
            },
        ]
    },
    {
        path: '/tag',
        component: Layout,
        redirect: '/tag/manager',
        children: [
            {
                path: 'manager',
                name: 'Tag',
                component: () => import('@/views/iori/tag/index')
            }
        ]
    },
    {
        path: '/lookup',
        component: Layout,
        redirect: '/lookup/list',
        children: [
            {
                path: 'list',
                name: 'Lookup',
                component: () => import('@/views/iori/lookup/index')
            }
        ]
    },
    {
        path: '/registry',
        component: Layout,
        redirect: '/registry/list',
        children: [
            {
                path: 'list',
                name: 'Registry',
                component: () => import('@/views/iori/registry/index')
            }
        ]
    },
    {
        path: '/ops',
        component: Layout,
        redirect: '/ops/auditLog',
        children: [
            {
                path: 'redisManager',
                name: 'redisManager',
                component: () => import('@/views/iori/ops/redisManager')
            },
            {
                path: 'asyncTaskTrace',
                name: 'AsyncTaskTrace',
                component: () => import('@/views/iori/ops/asyncTaskTrace')
            },
            {
                path: 'systemLog',
                name: 'SystemLog',
                component: () => import('@/views/iori/ops/systemLog')
            },
            {
                path: 'consulManager',
                name: 'ConsulManager',
                component: () => import('@/views/iori/ops/consul/index')
            },
        ]
    },
    // 操作日志
    {
        path: '/logger',
        component: Layout,
        redirect: '/logger/auditLog',
        children: [
            {
                path: 'auditLog',
                name: 'AuditLog',
                component: () => import('@/views/iori/logger/auditLog')
            },
        ]
    },
    {
        path: '/tenant/logger',
        component: Layout,
        redirect: '/logger/auditLog',
        children: [
            {
                path: 'auditLog',
                name: 'AuditLog',
                component: () => import('@/views/iori/logger/tenant/auditLog')
            },
        ]
    },
    // 人员管理
    {
        path: '/employee',
        component: Layout,
        redirect: '/employee/list',
        children: [
            {
                path: 'list',
                name: 'employeeManager',
                component: () => import('@/views/iori/employee/index')
            }
        ]
    },
    {
        path: '/tenant/employee/',
        component: Layout,
        redirect: '/tenant/employee/list',
        children: [
            {
                path: 'list',
                name: 'TenantEmployeeManager',
                component: () => import('@/views/iori/employee/tenant/index')
            },
        ]
    },
    // 组织结构
    {
        path: '/organization',
        component: Layout,
        redirect: '/organization/manager',
        children: [
            {
                path: 'manager',
                name: 'OrganizationManager',
                component: () => import('@/views/iori/organization/index')
            }
        ]
    },
    {
        path: '/tenant/organization/',
        component: Layout,
        redirect: '/tenant/organization/manager',
        children: [
            {
                path: 'manager',
                name: 'TenantOrganizationManager',
                component: () => import('@/views/iori/organization/tenant/index')
            },
        ]
    },
    //租户
    {
        path: '/tenant',
        component: Layout,
        redirect: '/tenant/manager',
        children: [
            {
                path: 'manager',
                name: 'Tenant',
                component: () => import('@/views/iori/tenant/index')
            }
        ]
    },
    //模块
    {
        path: '/modulx',
        component: Layout,
        redirect: '/modulx/template',
        children: [

            {
                path: 'template',
                name: 'ModulxTemplate',
                component: () => import('@/views/iori/modulx/template')
            },
            {
                path: 'tenant',
                name: 'ModulxTenant',
                component: () => import('@/views/iori/modulx/tenantModulx')
            },
            {
                path: 'pricing',
                name: 'ModulxPricing',
                component: () => import('@/views/iori/modulx/pricingModulx')
            }
        ]
    },
]

export default ioriRouter
